const refundFields = [
  {
    name: "reason",
    label: "Refund Reason",
    type: "textarea",
    placeholder: "Refund Reason",
  },
  {
    name: "payment_id",
    label: "Select Payment",
    type: "select",
    placeholder: "Select payment u want to refund",
    options: [],
  },
  {
    name: "course_id",
    label: "Course Title",
    type: "text",
    placeholder: "Course Title",
    options: [],
    value: "course_id",
  },
  {
    name: "employee_name",
    label: "Employee Name",
    type: "text",
    placeholder: "employee name",
    options: [],
    value: "employee_name",
  },
];

export default refundFields;
